/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export enum PathsApiAttachmentFileParseGetParametersQueryType {
    ecp = "ecp",
    gdv = "gdv",
    kb = "kb",
    slg = "slg"
}

export enum PathsApiInternallariitemGetParametersQueryIssue_assigneeOneOf1 {
    any = "any",
    none = "none"
}

export enum PathsApiInternallariitemGetParametersQueryIssue_closed {
    false = "false",
    none = "none",
    true = "true"
}

export enum PathsApiInternallariitemGetParametersQueryLang {
    bs = "bs",
    cnr = "cnr",
    de = "de",
    en = "en",
    fr = "fr",
    hr = "hr",
    it = "it",
    mk = "mk",
    sl = "sl",
    sq = "sq",
    sr = "sr",
    uk = "uk"
}

export enum PathsApiInternallariitemGetParametersQueryTable_closed {
    false = "false",
    none = "none",
    true = "true"
}

export enum PathsApiInternallariitemGetParametersQueryTable_ownerOneOf1 {
    any = "any",
    none = "none"
}

export enum PathsApiIssueGetParametersQueryStatus {
    closed = "closed",
    created = "created",
    draft = "draft",
    published = "published"
}

export enum PathsApiLarisearchGetParametersQueryIssue_assigneeOneOf1 {
    any = "any",
    none = "none"
}

export enum PathsApiLarisearchGetParametersQueryIssue_closed {
    false = "false",
    none = "none",
    true = "true"
}

export enum PathsApiLarisearchGetParametersQueryLang {
    bs = "bs",
    cnr = "cnr",
    de = "de",
    en = "en",
    fr = "fr",
    hr = "hr",
    it = "it",
    mk = "mk",
    sl = "sl",
    sq = "sq",
    sr = "sr",
    uk = "uk"
}

export enum PathsApiLarisearchGetParametersQueryTable_closed {
    false = "false",
    none = "none",
    true = "true"
}

export enum PathsApiLarisearchGetParametersQueryTable_ownerOneOf1 {
    any = "any",
    none = "none"
}

export enum PathsApiLarisearchIdRelatedGetParametersQueryKind {
    provides_schedule_for = "provides_schedule_for"
}

export enum PathsApiLarisearchIdRelatedGetParametersQueryOrder {
    schedule = "schedule",
    title = "title"
}

export enum PathsApiLarisearchIdSimilarGetParametersQueryIssue_assigneeOneOf1 {
    any = "any",
    none = "none"
}

export enum PathsApiLarisearchIdSimilarGetParametersQueryIssue_closed {
    false = "false",
    none = "none",
    true = "true"
}

export enum PathsApiLarisearchIdSimilarGetParametersQueryLang {
    bs = "bs",
    cnr = "cnr",
    de = "de",
    en = "en",
    fr = "fr",
    hr = "hr",
    it = "it",
    mk = "mk",
    sl = "sl",
    sq = "sq",
    sr = "sr",
    uk = "uk"
}

export enum PathsApiLarisearchIdSimilarGetParametersQueryTable_closed {
    false = "false",
    none = "none",
    true = "true"
}

export enum PathsApiLarisearchIdSimilarGetParametersQueryTable_ownerOneOf1 {
    any = "any",
    none = "none"
}

export enum PathsApiLarisearchIdSummaryGetParametersQueryLanguage {
    bs = "bs",
    cnr = "cnr",
    de = "de",
    en = "en",
    fr = "fr",
    hr = "hr",
    it = "it",
    mk = "mk",
    sl = "sl",
    sq = "sq",
    sr = "sr",
    uk = "uk"
}

export enum PathsApiLarisearchCountGetParametersQueryIssue_assigneeOneOf1 {
    any = "any",
    none = "none"
}

export enum PathsApiLarisearchCountGetParametersQueryIssue_closed {
    false = "false",
    none = "none",
    true = "true"
}

export enum PathsApiLarisearchCountGetParametersQueryLang {
    bs = "bs",
    cnr = "cnr",
    de = "de",
    en = "en",
    fr = "fr",
    hr = "hr",
    it = "it",
    mk = "mk",
    sl = "sl",
    sq = "sq",
    sr = "sr",
    uk = "uk"
}

export enum PathsApiLarisearchCountGetParametersQueryTable_closed {
    false = "false",
    none = "none",
    true = "true"
}

export enum PathsApiLarisearchCountGetParametersQueryTable_ownerOneOf1 {
    any = "any",
    none = "none"
}

export enum PathsApiReportGetParametersQueryStatus {
    closed = "closed",
    open = "open"
}

export enum PathsApiResolutionGetParametersQueryCouncil {
    NR = "NR",
    SR = "SR",
    V = "V"
}

export enum PathsApiTableGetParametersQueryStatus {
    closed = "closed",
    draft = "draft",
    open = "open"
}

export enum PathsApiTableRelatedLarisearch_idGetParametersQueryStatus {
    closed = "closed",
    draft = "draft",
    open = "open"
}

export enum PathsApiTranscriptGetParametersQueryCouncil {
    NR = "NR",
    SR = "SR"
}

export enum PathsApiVoteGetParametersQueryCouncil {
    NR = "NR",
    SR = "SR"
}

export enum PathsApiVoteTableGetParametersQueryCouncil {
    NR = "NR",
    SR = "SR"
}

export enum ActionEnum {
    attribute_added = "attribute_added",
    attribute_removed = "attribute_removed",
    copy = "copy",
    dictionary_item_added = "dictionary_item_added",
    dictionary_item_removed = "dictionary_item_removed",
    initiated = "initiated",
    iterable_item_added = "iterable_item_added",
    iterable_item_moved = "iterable_item_moved",
    iterable_item_removed = "iterable_item_removed",
    iterable_items_added_at_indexes = "iterable_items_added_at_indexes",
    iterable_items_deleted = "iterable_items_deleted",
    iterable_items_equal = "iterable_items_equal",
    iterable_items_inserted = "iterable_items_inserted",
    iterable_items_removed_at_indexes = "iterable_items_removed_at_indexes",
    iterable_items_replaced = "iterable_items_replaced",
    migrate_larisearch_id = "migrate_larisearch_id",
    set_item_added = "set_item_added",
    set_item_removed = "set_item_removed",
    type_changes = "type_changes",
    unordered_iterable_item_added = "unordered_iterable_item_added",
    unordered_iterable_item_removed = "unordered_iterable_item_removed",
    values_changed = "values_changed"
}

export enum ChangeParentKindEnum {
    table = "table",
    issue = "issue"
}

export enum ContentLanguagesEnum {
    en = "en",
    fr = "fr",
    it = "it",
    de = "de",
    bs = "bs",
    sr = "sr",
    hr = "hr",
    cnr = "cnr",
    mk = "mk",
    sq = "sq",
    sl = "sl",
    uk = "uk"
}

export enum DatacolumnTypeEnum {
  HTML = 2,
  DATE = 3,
  NUMBER = 4,
  LARISEARCH_ITEM = 5,
  USERS = 6,
  TAGS = 7,
  ISSUE = 8,
  MIRROR = 9,
  REPORT_ISSUE = 10,
  HYPERLINK = 11,
  ROW_METADATA = 12,
  BOOL = 13,
}

export enum DecisionEnum {
  JA = 1,
  NEIN = 2,
  ENTHALTUNG = 3,
  DID_NOT_PARTICIPATE = 5,
  EXCUSED = 6,
  PRESIDENT = 7,
}

export enum DocumentTypeEnum {
    html = "html",
    doc = "doc",
    rtf = "rtf",
    xls = "xls",
    pdf = "pdf"
}

export enum EmailInboxNotificationsEnum {
    none = "none",
    topics = "topics",
    attached = "attached",
    items = "items"
}

export enum EntityChangeKindEnum {
    monitoring_item = "monitoring_item",
    table_row = "table_row",
    issue_comment = "issue_comment",
    issue = "issue"
}

export enum FeatureFlagTypeNameEnum {
    TABLES = "TABLES",
    MIRRORING = "MIRRORING",
    TABLE_VIEWS_IN_ISSUES = "TABLE_VIEWS_IN_ISSUES",
    INTERNAL_LARI_ITEMS = "INTERNAL_LARI_ITEMS",
    TICKETING = "TICKETING",
    LARI_ITEM_HEADINGS = "LARI_ITEM_HEADINGS",
    TIME_TRACKING = "TIME_TRACKING",
    SUMMARY = "SUMMARY",
    CHARTS = "CHARTS",
    AI_CHAT = "AI_CHAT",
    AI_INBOX = "AI_INBOX",
    AUDIMEX_SHIP_ONCE = "AUDIMEX_SHIP_ONCE",
    POLITICIANS = "POLITICIANS",
    AI_TOPIC_CREATION = "AI_TOPIC_CREATION"
}

export enum FilterOperatorEnum {
    eq = "eq",
    neq = "neq",
    gt = "gt",
    lt = "lt",
    icontains = "icontains",
    between = "between",
    and = "and",
    or = "or"
}

export enum GenderEnum {
    F = "F",
    M = "M"
}

export enum IsInInboxEnum {
    update = "update",
    schedule = "schedule",
    new = "new",
    none = "none"
}

export enum IssueAttributes {
    created_at = "created_at",
    modified_at = "modified_at",
    creator = "creator",
    title = "title",
    description = "description",
    due_date = "due_date",
    due_date_notes = "due_date_notes",
    closed_by = "closed_by",
    assignee = "assignee",
    tags = "tags",
    collaborators = "collaborators",
    logs = "logs",
    project = "project",
    public = "public",
    issue_bookmarked = "issue_bookmarked",
    reported = "reported"
}

export enum IssueDetailWithOptimizedUsersCreateStatusEnum {
    draft = "draft"
}

export enum IssueLogBooleanFieldEntryPath {
    is_ticket = "is_ticket",
    public = "public"
}

export enum IssueLogCommentBooleanFieldEntryPath {
    is_visible_to_ticketing_user = "is_visible_to_ticketing_user",
    modified = "modified"
}

export enum IssueLogCommentIntegerFieldEntryPath {
    creator = "creator",
    id = "id",
    issue = "issue"
}

export enum IssueLogCommentStringFieldEntryPath {
    comment = "comment",
    language = "language"
}

export enum IssueLogStringFieldEntryPath {
    description = "description",
    due_date_notes = "due_date_notes",
    language = "language",
    published_description = "published_description",
    question = "question",
    title = "title"
}

export enum IssueLogTaskIntegerFieldEntryPath {
    creator = "creator",
    done_user = "done_user",
    id = "id",
    issue = "issue"
}

export enum IssueLogTaskStringFieldEntryPath {
    language = "language",
    title = "title"
}

export enum IssueLogUserFieldEntryPath {
    assignee = "assignee",
    closed_by = "closed_by",
    creator = "creator"
}

export enum IssueStatusEnum {
    created = "created",
    published = "published",
    closed = "closed",
    draft = "draft"
}

export enum LariItemLogBlocklistEntryPath {
    added_to_blocklist = "added_to_blocklist",
    removed_from_blocklist = "removed_from_blocklist"
}

export enum LariItemLogInboxEntryPath {
    went_to_inbox = "went_to_inbox",
    remove_from_inbox = "remove_from_inbox"
}

export enum LogSortingEnum {
    newest_first = "newest_first",
    oldest_first = "oldest_first"
}

export enum OpEnum {
    created = "created",
    updated = "updated",
    deleted = "deleted"
}

export enum OutcomeEnum {
    success = "success",
    failed = "failed",
    retry = "retry",
    denied = "denied",
    interrupted = "interrupted"
}

export enum ParseTypeEnum {
    gdv = "gdv",
    ecp = "ecp",
    slg = "slg",
    kb = "kb"
}

export enum RelatedEnum {
    provides_schedule_for = "provides_schedule_for"
}

export enum ReportStatusEnum {
    open = "open",
    closed = "closed"
}

export enum ResolutionCouncilEnum {
    SR = "SR",
    NR = "NR",
    V = "V"
}

export enum RowMetadataAttributes {
    created_at = "created_at",
    modified_at = "modified_at"
}

export enum SearchItemAttributes {
    title = "title",
    publication_date = "publication_date",
    description = "description",
    url_source = "url_source",
    schedule = "schedule",
    chronology = "chronology",
    authors = "authors",
    submission_date = "submission_date",
    decision_date = "decision_date",
    status = "status",
    proposal = "proposal",
    tags = "tags",
    references = "references",
    url_parent = "url_parent",
    document_type = "document_type",
    comment = "comment",
    timeline_events = "timeline_events",
    headings = "headings",
    rendered_headings = "rendered_headings",
    attached_to_issue = "attached_to_issue",
    attached_to_table = "attached_to_table",
    updated_on = "updated_on",
    acronym = "acronym"
}

export enum SortEnum {
    asc = "asc",
    desc = "desc"
}

export enum SubscriptionTypeEnum {
    daily = "daily",
    hot = "hot",
    none = "none"
}

export enum TableStatusEnum {
    open = "open",
    closed = "closed",
    draft = "draft"
}

export enum UpdateTypesEnum {
    os_update = "os_update",
    schedule_update = "schedule_update",
    new = "new"
}

export enum UserTypeEnum {
  FULL = 1,
  LIGHT = 2,
  TICKETING = 3,
}

export enum VoteCouncilEnum {
    SR = "SR",
    NR = "NR"
}

export enum ChatStreamEventEventEnum {
    message_start = "message_start",
    context = "context",
    reasoning = "reasoning",
    reasoning_delta = "reasoning_delta",
    text = "text",
    text_delta = "text_delta",
    tool_call_delta = "tool_call_delta",
    tool_call = "tool_call",
    tool_result = "tool_result",
    approval_required = "approval_required",
    entity_changed = "entity_changed",
    cost_usage = "cost_usage",
    warning = "warning",
    error = "error",
    done = "done",
    ping = "ping"
}

export enum TableCompletionStreamEventEventEnum {
    start = "start",
    done = "done",
    error = "error",
    cost_limit = "cost_limit",
    ping = "ping",
    finished = "finished"
}
